/* @flow */
import { downloadAgentIncentives } from '../../../services/IncentiveService';
import { useMutation } from 'react-query';
import type { File } from '../../../models/File';

type DownloadAgentIncentivesOptions = $ReadOnly<{
  onSuccess?: (isSuccessful: boolean, data: ?File) => void,
  onError?: (error: any) => void,
}>;

type DownloadAgentIncentives = $ReadOnly<{
  mutateAsync: (payPeriodId: number, options?: DownloadAgentIncentivesOptions) => Promise<void>,
  isLoading: boolean,
}>;

function useDownloadCommissionReviews(): DownloadAgentIncentives {
  const { mutateAsync, isLoading } = useMutation(async (payPeriodId: number) =>
    downloadAgentIncentives(payPeriodId),
  );

  return {
    mutateAsync: async (
      payPeriodId: number,
      options?: DownloadAgentIncentivesOptions,
    ): Promise<void> => {
      try {
        const data = await mutateAsync(payPeriodId);
        options?.onSuccess?.(true, data);
      } catch (e) {
        options?.onError?.(e);
      }
    },
    isLoading,
  };
}

export default useDownloadCommissionReviews;
